import React, { Component } from 'react';
import { Container, Button } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import Icon from '../Icon/Icon';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, eventId: null };
  }

  static getDerivedStateFromError(error) {
    return { error: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope(scope => {
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  getLocalString = (intl, id, defaultMessage) =>
    intl.formatMessage({
      id,
      defaultMessage,
    });

  sendReport = intl => {
    Sentry.showReportDialog({
      eventId: this.state.eventId,
      lang: 'ru',
      title: this.getLocalString(
        intl,
        'error.report.form.title',
        'It looks like we’re having issues.',
      ),
      subtitle: this.getLocalString(
        intl,
        'error.report.form.subtitle',
        'Our team has been notified.',
      ),
      subtitle2: this.getLocalString(
        intl,
        'error.report.form.subtitle.2',
        'If you’d like to help, tell us what happened below.',
      ),
      labelName: this.getLocalString(intl, 'error.report.form.label.name', 'Name'),
      labelComments: this.getLocalString(intl, 'error.report.form.label.comment', 'What happened?'),
      labelClose: this.getLocalString(intl, 'error.report.form.label.close', 'Close'),
      labelSubmit: this.getLocalString(intl, 'error.report.form.label.submit', 'Submit'),
      errorGeneric: this.getLocalString(
        intl,
        'error.report.form.error.generic',
        'An unknown error occurred while submitting your report. Please try again.',
      ),
      errorFormEntry: this.getLocalString(
        intl,
        'error.report.form.error.field',
        'Some fields were invalid. Please correct the errors and try again.',
      ),
      successMessage: this.getLocalString(
        intl,
        'error.report.form.success',
        'Your feedback has been sent. Thank you!',
      ),
      onLoad: this.getLocalString(intl, 'error.report.form.loading', 'Loading...'),
    });
  };

  render() {
    const { intl } = this.props;

    if (this.state.error) {
      //render fallback UI
      return (
        <div className="error-page">
          <Container className="text-center">
            <Icon type="help-bad" />
            <h1>
              <FormattedMessage id="error.report.title" defaultMessage="error.report.title" />
            </h1>
            <Button className='mr-3' href="/dashboard" tag={'a'} color="primary">
              <FormattedMessage id="not_found_page.back" defaultMessage="Back to homepage" />
            </Button>
            <Button onClick={() => window.location.reload()} color="primary">
              Обновить
            </Button>
          </Container>
        </div>
      );
    } else {
      //when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

export default injectIntl(ErrorBoundary);
